/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowShapeARightIcon24Solid = forwardRef('ArrowShapeARightIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M21.205 10.143a2.625 2.625 0 0 1 0 3.712l-8.73 8.73c-.913.913-2.475.266-2.475-1.026V18H4.25A2.25 2.25 0 0 1 2 15.75v-7.5A2.25 2.25 0 0 1 4.25 6H10V2.44C10 1.147 11.562.5 12.476 1.414l8.729 8.73Z" })));
});
